import React, { useEffect, useState } from "react";

import GoBackHeader from "../GoBackHeader/GoBackHeader";
import Departments from "../Departments/Departments";
import Footer from "../Footer/Footer";
import SchoolOverview from "../SchoolOverview/SchoolOverview";
import ExhibitionsOverview from "../ExhibitionsOverview/ExhibitionsOverview";

const Exhibitions = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
  const handleWidthChange = () => {
    // setWidth(window.innerWidth);
    // console.log("mobile", isMobile);
    if (window.innerWidth > 1000) {
      setIsMobile(false);
      // window.location.reload();
    } else if (window.innerWidth <= 1000) {
      setIsMobile(true);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleWidthChange);
    window.scrollTo({ top: 0 });
  }, []);

  if (!isMobile) {
    return (
      <>
        <GoBackHeader transparent={true}/>
        <Departments small={true} transparent={true}/>
        <ExhibitionsOverview/>
        {/* <Footer enableScroll={false} /> */}
        <div id="portal"></div>
      </>
    );
  } else {
    return (
      <>

      </>
    );
  }
};
export default Exhibitions;
